<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icons/mark-ok-bold">
      <path
        id="Union"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.8448 5.53479L11.3498 20.5348L10.674 21.6025L9.79016 20.6994L4.28516 15.0744L5.71453 13.6755L10.3357 18.3974L19.1549 4.46509L20.8448 5.53479Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
